import React, { Component } from 'react';
import {Form, Input, Row, Col, Button, message} from 'antd';

import { httpPost } from "http/index.js"

import './register.css'

class ResetPsdForm extends Component {
  state = {
    isHandle: false,
  }
  
  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div className="register-box">
        <div className="register-content">
          <Form {...formItemLayout} onSubmit={this.handleSubmit}>
            <Form.Item label="Username">
              {getFieldDecorator('username', {
                rules: [{ required: true, message: 'Please input your username!'}],
              })(<Input />)}
            </Form.Item>

            <Form.Item label="Token">
              <Row gutter={8}>
                <Col span={12}>
                  {getFieldDecorator('token', {
                    rules: [{ required: true, message: 'Please input the token you got!' }],
                  })(<Input />)}
                </Col>
                <Col span={12}>
                  <Button onClick={this.getCode} disabled={this.state.isHandle}>Get verification token</Button>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item label="Password">
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your password!',
                  },
                  
                ],
              })(<Input.Password />)}
            </Form.Item>
            
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Reset
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    )
  }

  handleSubmit = e => {
    e.preventDefault();
    
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) return;
      httpPost("/auth/reset_password", JSON.stringify(values))
        .then(res => {
          return res.json();
        })
        .then(data => {
          console.log(data);
          this.props.history.push('/login');
        })
        .catch(err => {
          message.error('Interface error: Register');
        })
    });
  };
  getCode = () => {
    const { form } = this.props;

    const username = (form.getFieldValue('username'));
    if (username) {
      this.setState({
        isHandle: true
      });
      this.timeoutID = setTimeout(() => {
        this.setState({isHandle: false})
      }, 5000)

      httpPost("/auth/get_token", JSON.stringify({username: username}))
        .then(res => {
          return res.json();
        })
        .then(data => {

          console.log(data);
          if (data.code === 0){
            message.success("Please check your phone!")
          }else{
            message.error('Interface error: Reset password');
          }
        })
        .catch(err => {
          message.error('Interface error: Reset password');
        })
    }else {
      message.error("Please input your username!");
    }
  }

}
const WrappedResetPsdForm = Form.create()(ResetPsdForm);

export default WrappedResetPsdForm;